<mat-card-header class="header-container">
    <div class="header">
      <mat-card class="psalogo">PSA logo</mat-card>
    </div>
    <div class="header-items">
      <div class="row">
        <div class="col-sm-8" style="text-align: center;">
          <b>
            <mat-label class="header-dmbr" style="margin-left: 125px;">{{'dmbr-bo_key' | translate}} </mat-label>
          </b>
        </div>
        <div class="col-sm-2 ">
          <div class="language-select">
            <mat-select matNativeControl #langSelect (selectionChange)="changeLang(langSelect.value)"
            [value]="translate.currentLang">
              <mat-option  value="en">
                English
              </mat-option>
              <mat-option  value="fr">
               French
              </mat-option>
            </mat-select>
          </div>
        </div>
        <div class="col-sm-1">
          <div class="col-space">
            <div class="userdetail">
              <span>{{username}} </span>
            </div>
            <div class="userdetail">
              <span>Admin </span>
            </div>
          </div>
        </div>
        <div class="col-sm-1">
          <div class="logout">
            <mat-icon (click)="logout()" svgIcon="power_settings" aria-hidden="false"></mat-icon>
          </div>
        </div>
      </div>
    </div>
  </mat-card-header>